import type {
  FirestoreRestaurantSupplierDocument,
  FirestoreSupplierDocument,
  Supplier,
} from "@dashboard/types/supplier";

import { readEntitySource } from "./entitySource";

// Converts a firestore supplier document to a supplier object
export const readSupplier = (doc: FirestoreSupplierDocument): Supplier => {
  const { id, name } = doc;

  const supplier: Supplier = {
    id,
    name,
    type: "central",
    source: null, // Central suppliers are created by us and don't have a source
  };

  return supplier;
};

export const readRestaurantSupplier = (
  doc: FirestoreRestaurantSupplierDocument
): Supplier => {
  const { id, name, source } = doc;

  const supplier: Supplier = {
    id,
    name,
    type: "restaurant",
    source: readEntitySource(source),
  };

  return supplier;
};
